import { Link } from "react-router-dom";
import { Reveal } from "@/components/common/Reveal";
import { Ridgeline } from "@/components/common/Ridgeline";

export const ClosingCta = () => {
  return (
    <section
      className="grain relative overflow-hidden"
      style={{ backgroundColor: "#24382E" }}
      data-nav-theme="dark"
      data-testid="home-closing"
    >
      <div className="relative z-10 mx-auto max-w-[1440px] px-6 pt-28 pb-16 text-center md:px-10 md:pt-44">
        <Reveal>
          <h2
            className="font-display mx-auto"
            style={{ fontSize: "clamp(56px,11vw,140px)", color: "#F8F5EF", lineHeight: 0.95 }}
          >
            Go far. <span className="italic" style={{ color: "#E3B268" }}>Come home.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.08}>
          <p className="mx-auto mt-8 max-w-[52ch] text-[17px] md:text-[18px]" style={{ color: "rgba(237,233,224,0.78)" }}>
            Whether you're moving in or handing us the keys — this is where it starts.
          </p>
        </Reveal>
        <Reveal delay={0.14}>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
            <Link to="/contact" className="pill pill-gold text-base" data-testid="closing-find-home">
              Find your home
            </Link>
            <Link
              to="/owners#analysis"
              className="pill text-base"
              style={{ border: "1px solid rgba(237,233,224,0.85)", color: "#F8F5EF" }}
              data-testid="closing-owner-cta"
            >
              Talk to us about your property
            </Link>
          </div>
        </Reveal>
      </div>

      <div className="relative z-0 mt-16 w-full opacity-80" aria-hidden="true">
        <Ridgeline stroke="#C89A4E" animate height={150} />
      </div>
    </section>
  );
};

export default ClosingCta;
